<template>
    <div class="min-height row">
        <!-- Toggle button: appears only under 869px and when navbar is hidden -->
        <div class="toggle-btn-wrapper col-12 p-0 mt-1" v-if="!mobileShow">
            <button class="btn close" @click="toggleMobileShow">
                <icon icon="Menu" />
            </button>
        </div>

        <div class="d-flex" :class="isMobile ? '' : 'ps-0'" style="gap: calc(var(--bs-gutter-x) * 0.8);">
            <!-- Navbar: shown based on screen width and mobileShow -->
            <div :class="[
                'navbar_wrapper',
                showNavbar && !isMobile ? '' : 'col-12',
                isMobile && !mobileShow ? 'd-none ' : '']">
                <NavbarVertical class="navbar" :class="showNavbar && !isMobile ? '' : 'navbar_mobile'"
                    @update-mobile-show="handleMobileShowUpdate" />
            </div>

            <!-- Content: full width if navbar is hidden or in mobile view -->
            <div :class="[
                'content_wrapper',
                showNavbar && !isMobile ? '' : 'col-12',
                isMobile && mobileShow ? 'd-none' : '', isMobile ? 'pe-0' : 'pe-2']">
                <div :class="['upper-content', headerTranslation ? 'd-block' : 'd-none']">
                    <!-- <div class="route" :class="['route', showRoute ? 'mb-2' : '']">
                    <BreadCrumbNavigation />
                </div> -->
                    <div class="d-flex justify-content-between">
                        <div v-if="headerTranslation" :class="['page_header', isMobile ? 'mb-3' : '']">
                            <h3 class="pt-1">{{ headerTranslation }}</h3>
                        </div>
                        <div class="language_selector">
                            <LanguageSelector />
                        </div>
                    </div>
                </div>
                <div class="content my-3">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavbarVertical from "@/components/NavbarVertical.vue";
import LanguageSelector from '@/components/LanguageSelector.vue';
import BreadCrumbNavigation from '@/components/BreadCrumbNavigation.vue';

export default {
    components: {
        NavbarVertical,
        LanguageSelector,
        BreadCrumbNavigation
    },
    props: {
        showNavbar: {
            type: Boolean,
            default: false,
            required: true
        }
    },
    data() {
        return {
            mobileShow: false,
            windowWidth: window.innerWidth,
            showRoute: true
        };
    },
    computed: {
        headerTranslation() {
            const header = this.$route.meta.header;
            return header ? this.$t(header) : null;
        },
        isMobile() {
            // Sidebar layout from 992px up (tablets landscape + laptops + desktop);
            // hamburger drawer below that (phones + small/portrait tablets).
            const mobile = this.windowWidth < 992;
            this.$store.commit('updateMobile', mobile);
            return mobile;
        }
    },
    methods: {
        toggleMobileShow() {
            this.mobileShow = !this.mobileShow;
        },
        handleMobileShowUpdate(show) {
            this.mobileShow = show;
        },
        updateWindowWidth() {
            this.windowWidth = window.innerWidth;
        }
    },
    mounted() {
        window.addEventListener('resize', this.updateWindowWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateWindowWidth);
    }
};
</script>



<style lang="scss">
@import "@/scss/main.scss";
@import "@/scss/abstracts/variables";

.navbar_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}

@media (min-width: 992px) {
    .navbar_wrapper {
        flex: 0 0 260px; // pin the sidebar so wide content can't shrink it
        width: 260px;
        max-width: 260px;
    }
}

.content_wrapper {
    flex: 1 1 auto;
    min-width: 0; // allow wide children (tables) to scroll internally instead of overflowing
}

@media (max-width: 991px) {
    .navbar_mobile {
        width: 100% !important;
    }
}

.min-height {
    min-height: 100vh;
    background: $bg-app;
    color: $text;
}

.upper-content {
    margin: 20px 0 20px 0;
}

.language_selector {
    display: flex;
    align-items: center;
}

.content {
    font-family: "Inter";
}

.close {
    padding: 6px 8px;

    svg {
        stroke: $accent;
        width: 30px;
        height: 30px;
    }
}

.page_header {
    background: transparent;
    box-shadow: none;
    padding: 0;
    display: flex;
    align-items: center;
    height: 100%;

    h3 {
        position: relative;
        margin: 0;
        padding-left: 16px;
        color: $text;
        font-size: clamp(22px, 3vw, 32px);
        font-weight: 700;
        letter-spacing: 0.2px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 8%;
            bottom: 8%;
            width: 5px;
            border-radius: $radius-pill;
            background: $accent;
        }
    }
}

.route {
    background: $gradient-brand;
    box-shadow: $shadow-md;
    padding: 5px 25px;
    border-radius: $radius-lg;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    text-align: center;
    width: fit-content;

    span {
        margin-top: auto;
        margin-bottom: auto;
        font-size: 22px;
        font-weight: 400;
        letter-spacing: 0.5px;
    }
}

@media (min-width: 1400px) and (max-width: 1700px) {

    .row>.col-3,
    .row>.col-md-4,
    .row>.col-xl-3,
    .row>.col-xxl-2 {
        flex: 0 0 auto;
        width: 25%;
    }

    .row>.col-md-8,
    .row>.col-xl-9,
    .row>.col-xxl-10 {
        flex: 0 0 auto;
        width: 75%;
    }
}

.toggle-btn-wrapper {
    display: none;

    @media (max-width: 991px) {
        display: block;
    }
}

.content-wrapper {
    @media (max-width: 999px) {
        width: 100%;
    }
}
</style>